import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import { DefeatAllUnitsOfAffiliation, HealPlayerPartyScript, Dialogue, MoveUnit, MoveEncounterScript, EscapeScript, SpawnUnitsScript } from "@frog/source/data/plotscripts.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/admin/Navigation.js"

const tiledWorld = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/tileset.json"),
})

export default {
    "slug": "avarice",
    "hasPreparePhase": false,
    "startingEncounter": "1",

    "stage": {
        "image": require("./environment.png"),
        "world": tiledWorld,
        "units": require("./units.json"),
        "conditions": [
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "good",
                    })
                },
                "events": [
                    {"type": "chapter failure"},
                    {"func": () => App.game.chapter.restart()},
                ]
            },
            {
                "type": "turn:0:start",
                "events": [
                    {"func": () => Audiomix.trigger("Hell:Music:2")},
                    {
                        "type": "Dialogue",
                        "deltastages": [
                            {
                                "mark": 0,
                                "dialogue": {"type": "banner", "data": {"color": "#000"}},
                            },
                            {
                                "mark": 3200,
                                "dialogue": {"type": "banner", "data": {"color": "#000"}, "text": "HELLWARDS"}
                            },
                            // {
                            //     "mark": 13000,
                            //     "dialogue": {"type": "banner", "data": {"color": "#000"}}
                            // },
                            {
                                "mark": 11000,
                                "dialogue": {"type": "banner", "data": {"color": "#000"}, "text": "CHAPTER 2"}
                            },
                            {
                                "mark": 16000,
                                "dialogue": {"type": "banner", "data": {"color": "#000"}}
                            }
                        ]
                    },
                    {
                        "deltastages": [
                            {
                                "mark": 0,
                                "dialogue": undefined
                            }
                        ]
                    },
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 1,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 2})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 2,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 3})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 3,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 4})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 4,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 5})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 5,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 6})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 6,
                    })
                },
                "events": [
                    {"func": () => Audiomix.trigger("Hell:Music:Victory")},
                    {"type": "chapter success"},
                    {"func": () => Navigation.go("/games/hell/chapters/sorrow")},
                ]
            },
        ]
    },
}
